"use strict";
// tslint:disable: no-any
Object.defineProperty(exports, "__esModule", { value: true });
var Source = /** @class */ (function () {
    function Source(settings) {
        this.settings = [];
        this.settings = settings || [];
    }
    Source.prototype.select = function (key) {
        if (!key) {
            return this.settings.slice();
        }
        return this.settings.filter(function (setting) { return setting.key === key; });
    };
    return Source;
}());
exports.Source = Source;
//# sourceMappingURL=source.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@cian/config/shared/source.js
// module id = 247
// module chunks = 0